export const AutomaticReminders = "AutomaticReminders";
export const AutoDividendAnnualAccounts = "AutoDividendAnnualAccounts";
export const RouteGenericVoucherToSupplierInvoice = "RouteGenericVoucherToSupplierInvoice";
export const AuditorCommunicationPanel = "AuditorCommunicationPanel";
